import {
  Company,
  Resource,
  TaskAssignedResource,
  Team,
} from '@dispatch/shared/types';
import { Grid, Skeleton, Stack } from '@mui/material';
import { ResourceP } from '../../TaskDetailsStyles';

export const AssignedResourceSection = ({
  assignedResourceData,
  resourceData,
  isAssigning,
  company,
  assignedResource,
}: {
  assignedResourceData?: TaskAssignedResource | null;
  resourceData?: TaskAssignedResource | null;
  isAssigning: boolean;
  company?: Company;
  assignedResource: Resource | undefined;
}) => {
  const findResourceTeam = () => {
    return (
      company?.team?.filter(
        (t: Team) => t.integrationGUID === (resourceData as any)?.teamId
      )?.[0]?.name || ''
    );
  };

  return (
    <Grid container spacing={4} data-testid="assigned-resource">
      <Grid>
        <Stack>
          <ResourceP>Resource Name</ResourceP>
          {isAssigning ? (
            <Skeleton animation="wave" />
          ) : (
            <p
              style={{
                whiteSpace: 'nowrap',
                marginTop: 0,
                paddingTop: 0,
              }}
            >
              {`${assignedResourceData?.name || '--'}`}
            </p>
          )}
        </Stack>
      </Grid>
      <Grid>
        <Stack>
          <ResourceP>ID</ResourceP>
          {assignedResource?.companies?.[0]?.externalResourceId || '--'}
        </Stack>
      </Grid>
      <Grid>
        <Stack>
          <ResourceP>Team</ResourceP>
          {isAssigning ? (
            <Skeleton animation="wave" />
          ) : (
            findResourceTeam?.() || '--'
          )}
        </Stack>
      </Grid>
    </Grid>
  );
};
